// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/foreign-licence-conversion.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/foreign-licence-conversion/foreign-licence-conversion.js';

mount([g0]);
